<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Setting Layout Lines - CASHFLOW, CHANGE IN EQUITY, etc. 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click.stop="saveLayout()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Cancel</b-button>

        </div>
      </div>
      <b-row >
        <b-col cols="5">
                <b-form-group label-cols=3 label="Line Layout Name">
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts"></b-form-select>
                </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label-cols=3 label="New Layout Name">
              <b-form-input v-model="filter.newLayout" v-b-tooltip.hover title="Define here! CASHFLOW(indirect), CHANGE IN EQUITY, etc."></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-cols=3 >
                <b-button class="btn btn-danger" @click.stop="delLayout()" > <i class="fa fa-trash"></i> Delete</b-button>
          </b-form-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        bordered
        responsive striped hover small
        style="font-size:smaller;" 
        :items="tblData.items"
        :fields="tblData.fields"
        @row-click="rowClicked" 
      >
        <template v-slot:cell(uraian)="data">
          <span v-if="(data.item.judul=='Y')" v-html="data.item.uraian" style="font-weight:bold;" :style="`margin-left:${data.item.spasi*5}px`"></span>
          <span v-else v-html="data.item.uraian" :style="`margin-left:${data.item.spasi*5}px`"></span>
        </template>

        <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click.stop.stop="insertClick($event, data.item, data.index)">
                insert
              </a>
              |
              <a href="javascript:void(0)" @click.stop="editLine(data.item,data.toggleDetails)">
                edit
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="delLine(data.index)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
        </template>
      <template v-slot:row-details="row">
        <b-card no-body class="row-details-form">
          <b-row class="mt-2 mr-2">
            <b-col class="pr-1" cols="6">
                <b-form-group label-cols=3 label="GL Account">
                  <b-input-group >
                      <b-form-input readonly v-model="tblData.obj.glAccount" @keyup.13.native="lkuCoaShow=true"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click.stop="lkuCoaShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>                      
                </b-form-group>
                <b-form-group label-cols=3 label="Source Code">
                  <b-form-row>
                    <b-col md="5">
                    <b-form-input v-model="tblData.obj.kode" placeholder="kode"></b-form-input>
                    </b-col>
                    <b-col md="7">
                      <b-input-group >
                          <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Source Field</span></b-input-group-prepend>
                        <b-form-select v-model="tblData.obj.kodekol" :plain="true" :options="rptkodekoloms"></b-form-select>                          
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                </b-form-group>
                <b-form-group  label-cols=3  label="Description(printed)" >
                    <b-form-input v-model="tblData.obj.uraian" ></b-form-input>
                </b-form-group>
                <b-form-group label-cols=3  label="Description Space" >
                    <b-input-group >
                        <b-form-input v-model="tblData.obj.spasi" placeholder="Space" type="number" class="mr-3"></b-form-input>
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Seq.No. </span></b-input-group-prepend>
                        <b-form-input v-model="tblData.obj.nomor" placeholder="Space" type="number" class="mr-3"></b-form-input>
                        <b-input-group-prepend><span class="pt-2 mr-2">Font Bold </span></b-input-group-prepend>
                        <b-form-select v-model="tblData.obj.judul" :plain="true" :options="dataList.FontBold"></b-form-select>                          
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label-cols=3  label="Row Name " >
                    <b-row>
                        <b-col cols="6"><b-form-input v-model="tblData.obj.nm_rumus" placeholder="Name"></b-form-input></b-col>
                    </b-row>
                </b-form-group>
                <b-form-group label-cols=3  label="Row Formula " >
                      <b-form-input v-model="tblData.obj.rumus" placeholder="Row Formula"></b-form-input>
                </b-form-group>
                <b-form-group label-cols=3  label="Subtotal Flag " >
                    <b-row>
                        <b-col cols="3">
                          <b-form-select v-model="tblData.obj.tanda_hit" :plain="true" :options="dataList.FlagTotal"></b-form-select>                          
                        </b-col>
                        <b-col cols="5">
                          <b-form-group label-cols=6 label="Hide (not printed)">
                                <b-form-select v-model="tblData.obj.item_hapus" :plain="true" :options="dataList.YesNo"></b-form-select>                          
                          </b-form-group>
                        </b-col>  

                    </b-row>
                </b-form-group>
                
            </b-col>
          </b-row>
            <b-row class="justify-content-center mb-2">
                <b-button class="btn btn-info mr-1" @click.stop="saveLine()">Update</b-button>
                <b-button class="btn btn-warning ml-1" @click.stop="row.toggleDetails">Close</b-button>
            </b-row>
        </b-card>
      </template>                        
      </b-table>
      <b-row class="justify-content-center mb-2">
          <button class="btn btn-primary mr-1" @click="saveLayout()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
      </b-row>

    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>        
        <vue-simple-context-menu
            :elementId="'myUniqueId'"
            :options="contextMenu"
            :ref="'vueSimpleContextMenu'"
            v-on:clicked="optionClicked">
        </vue-simple-context-menu>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#0000ff" ></loading>       

  </div>
</template>

<style lang="scss">
  .vue-simple-context-menu {
      &--active {
      }
  
      &__item {
          &:hover { }
      }
  }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
// import VueSimpleContextMenu from 'vue-simple-context-menu';
import VueSimpleContextMenu from "../../components/vue-simple-context-menu";
import lkuCoa from "../lookup/lkuConsolidaCoa";
import moment from 'moment';
import toastr from "mini-toastr";
import fp from "../../apis/consolidacashflw_indi";
import dropdown from "../../data/dropdown";

toastr.init();

export default {
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      horizontal: true,
      layouts:[],rptkodekoloms:[],
      lkuCoaShow:false,
      tahun: (this.$store.state.user.tglaktifconsol || '').substring(0, 4) || moment().format('YYYY'),
      isLoading:false,
      filter:{newLayout:''},
      model:{},
      contextMenu:[
        {name:'Insert 2 Rows', handler:'insert2Row'},
        {name:'Insert 4 Rows', handler:'insert4Row'},
        {name:'Insert 6 Rows', handler:'insert6Row'}
      ],
      tblData: {
        items: [{nomor:1,kode:''},{nomor:2,kode:''}],
        selected:{},
        obj:{},
        fields: [
          {
            key: "kode",
            label: "Src.Code",
            thStyle: "width:100px",
          },
          {
            key: "namakol",
            label: "Src.Field",
            thStyle: "width:100px",
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "spasi",
            thStyle: "width:40px",
            label: "Space"
          },
          {
            key: "judul",
            thStyle: "width:40px",
            label: "Bold"
          },
          {
            key: "nm_rumus",
            thStyle: "width:60px",
            label: "Row Name"
          },
          {
            key: "rumus",
            thStyle: "width:200px",
            label: "Row Formula",
          },
          {
            key: "tanda_hit",
            thStyle: "width:40px",
            label: "Flag Total"
          },
          {
            key: "item_hapus",
            label: "Hide",
            thStyle: "width:40px",
          },
          {
            key: "action",
            label: "Action",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:140px",
          },
        ],        
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      dataList: {
        YesNo: dropdown.YesNo,
        FontBold: dropdown.FontBold,
        FlagTotal: dropdown.FlagTotal
      }      

    };
  },
components: { lkuCoa,Loading,VueSimpleContextMenu },  
computed:{
      layout() {
          return this.filter.layout;
      }
  },
watch:{
      layout: async function(newval) {
          this.filter.newLayout=newval;
          this.tblData.items = await fp.layout({layout : newval});
      }
  },  
created: async function (){
    const [a,b] = await Promise.all([fp.layout_combo(), fp.rptkodekolom()]) ;
     this.layouts = a;
     this.rptkodekoloms= b;
     const { user } = this.$store.state;
     this.tahun=moment(user.tglaktifconsol).format('YYYY');
    //  this.filter.layout=this.layouts[0].value;
  },
  methods: {
    data: function(ctx) {
      return this.tblData.items;
    },
    saveLayout: async function(){
      if (this.filter.newLayout){
        console.log('save');
        try {
          this.isLoading=true;
          this.tblData.items.forEach((line,idx)=>{
            this.tblData.items[idx].nomor=idx+1;
              if (this.filter.newLayout !== this.filter.layout) {
                this.tblData.items[idx].idrowunik='';
              }
          });
          await fp.layoutSave({kodefmt:this.filter.newLayout, lines:this.tblData.items});
          this.layouts.push({value:this.filter.newLayout, text:this.filter.newLayout});
          this.isLoading=false;

        } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
        }
      } else {
            toastr.error('Please Fill "New Layout Name"');
      }

    },
    delLayout: async function(){
        this.isLoading=true;
        try {
          await fp.layoutDel(this.filter);
          this.layouts = await fp.layout_combo();
          this.isLoading=false;          
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
      router.push("home");
    },
    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        this.model.index = index;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    closeLine: function(){
        const opened= this.tblData.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addLine : function () {
        this.closeLine();
        const obj={_showDetails:true};
        this.tblData.selected = obj;
        for (var key in this.tblData.obj) {
            this.tblData.obj[key] = '';
        }
        this.tblData.items.push(obj);
        this.tblData.total=this.tblData.items.length;
    },
    editLine : function (obj,callback) {            
        this.closeLine();
        this.tblData.selected = obj;
        for (var key in this.tblData.obj) {
            this.tblData.obj[key] = '';
        }
        for (var key in obj) {
            this.tblData.obj[key] = obj[key];
        }
        if (callback) { callback(); 
        } else {
            this.$set(obj, '_showDetails', true);
            // this.tblData.selected._showDetails = true;
        }
    },
    delLine: function (index) {
        if (index > -1) {
        this.tblData.items.splice(index, 1);
        }
        this.tblData.total=this.tblData.items.length;
    },
    saveLine: function (callback) {
        this.tblData.obj.kode=(this.tblData.obj.kode || '').trim();
        if (this.tblData.obj.kode) {
          this.tblData.obj.kodekol = this.tblData.obj.kodekol || 'sdakhir';
          this.tblData.obj.namakol=(this.rptkodekoloms.find(d => d.value === this.tblData.obj.kodekol) || {}).text;
        } else {
          this.tblData.obj.kodekol=''
        };
        for (var key in this.tblData.obj) {
            this.tblData.selected[key] = this.tblData.obj[key];
        }
        // this.tblData.selected._showDetails=false;
        if (callback) {callback();
        } else {
          this.$set(this.tblData.selected, '_showDetails', false);
        }
        const sortedLines= this.tblData.items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this.tblData.items= sortedLines;                
    },
    insertClick (event, item, index) {
      // this.contextMenu=[
      //   {name:'Insert 2 Rows', handler:'insert2Row', index:index},
      //   {name:'Insert 4 Rows', handler:'insert4Row', index:index},
      //   {name:'Insert 6 Rows', handler:'insert6Row', index:index},
      // ],
        this.contextMenu.forEach((m,i) => {
            this.contextMenu[i].index=index;
        });
        this.$refs.vueSimpleContextMenu.showMenu(event, item);
    },    
    optionClicked (event) {
        this[event.option.handler](event.option.index,event.item);
    },
    insert2Row (index,item) {
        let nomor=item.nomor;
        this.tblData.items.splice(index, 0, {nomor: nomor+1 },{nomor: nomor+2});        
        for (let idx = this.tblData.items.length; idx > 0; idx-=1) {
          this.tblData.items[idx-1].nomor = idx;
        }             
        const sortedLines= this.tblData.items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this.tblData.items= sortedLines;                
    },
    insert4Row (index,item) {
        let nomor=item.nomor;
        this.tblData.items.splice(index, 0, {nomor: nomor+1 },{nomor: nomor+2},{nomor: nomor+3},{nomor: nomor+4});        
        for (let idx = this.tblData.items.length; idx > 0; idx-=1) {
          this.tblData.items[idx-1].nomor = idx;
        }             
        const sortedLines= this.tblData.items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this.tblData.items= sortedLines;                
    },
    insert6Row (index,item) {
        let nomor=item.nomor;
        this.tblData.items.splice(index, 0, {nomor: nomor+1 },{nomor: nomor+2},{nomor: nomor+3},{nomor: nomor+4},{nomor: nomor+5},{nomor: nomor+6});        
        for (let idx = this.tblData.items.length; idx > 0; idx-=1) {
          this.tblData.items[idx-1].nomor = idx;
        }             
        const sortedLines= this.tblData.items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this.tblData.items= sortedLines;                
    },
    onSelectLkuCoa(_selected) {
        this.tblData.obj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.tblData.obj.kode = _selected.kodeacc;
        this.tblData.obj.kodeacc = _selected.kodeacc;
        this.tblData.obj.namaacc = _selected.namaacc;
        this.tblData.obj.uraian = _selected.namaacc;
        this.lkuCoaShow=false;
    },


  }
};
</script>
